import { Button, Card, Form, Row, Col } from "react-bootstrap";
import { useState } from "react";

import consumerService from "../../services/consumer.service";
import Loading from "components/Util/Loading";

export default function Migration(props) {
  const [migrationMobile, setMigrationMobile] = useState();
  const [migrationStatus, setMigrationStatus] = useState(false);

  const checkMigration = async () => {
    try {
      setMigrationStatus(true);

      const response = await consumerService.checkMigration(
        migrationMobile.trim()
      );
      props.notify("tr", "success", `${response.data.message}`);
    } catch (err) {
      console.log(err);
    } finally {
      setMigrationStatus(false);
    }
  };

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center mb-3">
        <Card.Title as="h4" className="mb-0">
          Migration хийх
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col sm="12">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                checkMigration();
              }}
            >
              <Form.Row className="align-items-center">
                <Form.Group as={Col} controlId="formGridEmail">
                  <Form.Label>Дугаар</Form.Label>
                  <Form.Control
                    type="number"
                    value={migrationMobile}
                    onChange={(e) => {
                      setMigrationMobile(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} sm="3" controlId="formGridPassword">
                  {migrationStatus ? (
                    <>
                      <Loading loading={migrationStatus} />
                    </>
                  ) : (
                    <>
                      <Button
                        style={{ marginTop: "20px" }}
                        variant="primary"
                        className="btn btn-sm"
                        size="md"
                        onClick={checkMigration}
                      >
                        Шалгах
                      </Button>
                    </>
                  )}
                </Form.Group>
              </Form.Row>
            </Form>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
